module.exports = function() {
  return new Worker(__webpack_public_path__ + "62ed3dc3c435720b8906.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./node_modules/react-pdf/dist/pdf.worker.entry.js
// module id = 323
// module chunks = 1